module.exports = __webpack_public_path__ + "static/media/black-back-closed-envelope-shape.20b54433.svg";